/**
 * @name armenian-dram
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMTBoOCIgLz4KICA8cGF0aCBkPSJNMTEgMTRoOCIgLz4KICA8cGF0aCBkPSJNMTcgMjBWMTBhNiA2IDAgMCAwLTEyIDAiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/armenian-dram
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const ArmenianDram: string = `
<svg
  class="lucide lucide-armenian-dram"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M11 10h8" />
  <path d="M11 14h8" />
  <path d="M17 20V10a6 6 0 0 0-12 0" />
</svg>
`;

export default ArmenianDram;
